import { timerActions } from "../../../store/timerSlice";
import { UrlConstant } from "../../../urlConstant/UrlConstant";
import { useHttpRequest } from "../../../utils";
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack";
import { CommunicationFilter,  } from "../types";

export const GetCommunicationMutation = <T>(
  filter: CommunicationFilter,
  callbacks?: Callbacks<T>
) => {
  const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks);

  const { postRequest } = useHttpRequest({});
  return async (dispatch: any) => {
    const getTimers = async () => {
      try {
        const response = await postRequest(
          `${UrlConstant.GMailAddOn}/${UrlConstant.GetCommunications}`,
          filter
        );
        const data = await response;
        return data;
      } catch (error) {
        onError(error as Error);
      }
    };
    try {
      const res = await getTimers();
      if (res) {
        if (res?.succeeded) {
          const response = res?.data ?? [];
          if (response && Array.isArray(response)) {
            dispatch(timerActions.getCommunication(response?.[0]));
            onSuccess(response?.[0]);
          } else {
            dispatch(timerActions.getRecord(response));
          }
        }
      }
    } catch (error) {
      onError(error as Error);
    } finally {
      onLoading(false);
    }
  };
};
